import { BrowserRouter, Route, Routes } from 'react-router-dom'
import { Layout } from './components/Layout'
import { ProtectedRoute } from './components/ProtectedRoute'
import { AuthProvider } from './contexts/AuthContext'
import { DirtyProvider } from './contexts/DirtyContext'
import { ThemeProvider } from './contexts/ThemeContext'
import { AdminPage } from './pages/AdminPage'
import { EditorPage } from './pages/EditorPage'
import { ExplorePage } from './pages/ExplorePage'
import { HomePage } from './pages/HomePage'
import { LoginPage } from './pages/LoginPage'
import { LibraryPage, ReportDetailPage } from './pages/LibraryPage'
import { NotFoundPage } from './pages/NotFoundPage'
import { PoliciesPage } from './pages/PoliciesPage'
import { PlaylistPlaybackPage } from './pages/PlaylistPlaybackPage'
import { ProjectsPage } from './pages/ProjectsPage'
import { SharePage } from './pages/SharePage'
import { SupportPage } from './pages/SupportPage'

export default function App() {
  return (
    <BrowserRouter>
      <ThemeProvider>
        <AuthProvider>
          <DirtyProvider>
            <Routes>
              <Route element={<Layout />}>
              <Route index element={<HomePage />} />
              <Route path="explore" element={<ExplorePage />} />
              <Route path="share/:shareSlug" element={<SharePage />} />
              <Route path="reports/receipt/:token" element={<ReportDetailPage receipt />} />
              <Route path="support" element={<SupportPage />} />
              <Route path="policies" element={<PoliciesPage />} />
              <Route path="login" element={<LoginPage />} />
              <Route
                path="projects"
                element={
                  <ProtectedRoute>
                    <ProjectsPage />
                  </ProtectedRoute>
                }
              />
              <Route path="library" element={<ProtectedRoute><LibraryPage /></ProtectedRoute>} />
              <Route path="playlists/:playlistId/play" element={<ProtectedRoute><PlaylistPlaybackPage /></ProtectedRoute>} />
              <Route path="library/reports/:reportId" element={<ProtectedRoute><ReportDetailPage /></ProtectedRoute>} />
              <Route
                path="projects/new"
                element={
                  <ProtectedRoute>
                    <EditorPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="projects/:projectId/edit"
                element={
                  <ProtectedRoute>
                    <EditorPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="admin"
                element={
                  <ProtectedRoute admin>
                    <AdminPage />
                  </ProtectedRoute>
                }
              />
              <Route path="*" element={<NotFoundPage />} />
              </Route>
            </Routes>
          </DirtyProvider>
        </AuthProvider>
      </ThemeProvider>
    </BrowserRouter>
  )
}
